/**
 * Created by shubham on 24/4/18.
 */

import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog } from '@angular/material';
import { DialogComponent, WelcomeDialogComponent } from '../dialog/dialog.component';
import { CommonService } from '../shared/services/common.service';
import { PartnersPage } from "./partners-datatable/partners-page";
import { FormGroup, FormBuilder } from '@angular/forms';
import { APPCONFIG } from '../config';
import { PartnersDashboardResultService } from '../partnersDashboardResultService';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'partners-dashboard',
    template: require('./partners-dashboard.component.html')
})
export class PartnersDashboardComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    PartnersFiltersForm: FormGroup;
    userDetails:any;
    urlId: any;
    page = new PartnersPage();
    tableRows :any = [];
    filters:any = {};
    rows:any;
    partnersDashboardData = [];
    temp = [];
    showTable:boolean = true;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    selected = [];
    selectedCount: any;
    count: any;
    totalCount: any;
    searchedFilters= { email:'', firstName:'', wpassId:'' };
    partnersText: any;
    selectedStatusId: string = '';
    firstName = '';
    email = '';
    wpassId = '';
    isDisabled = false;
    showCheckbox = false;
    wpassLogin: boolean = false;
    type='';
    dataTableMessage = {'selectedMessage':'','totalMessage':''};
    StatusData = [{
        "id": "",
        "code": "",
        "name": "All"
    }];

    constructor(private router: Router, private route: ActivatedRoute, private httpService:HttpService, private sessionHandler:SessionHandler,
                private formBuilder: FormBuilder, public dialog: MdDialog, private serverResultsService: PartnersDashboardResultService,  
                private commonService: CommonService, private translate: TranslateService) {

        //Close Sidebar Initially
        APPCONFIG.navCollapsed = true;

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.partnersText = 'partners';

        this.wpassLogin = JSON.parse(this.sessionHandler.getItem('wpassLogin'));
        if(this.wpassLogin != null && this.wpassLogin == true){
            this.dialogRef = this.dialog.open(WelcomeDialogComponent);
            this.dialogRef.afterClosed().subscribe(result => {
                localStorage.removeItem('wpassLogin');
            });
        }

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        //Get URL param value
        this.route.params.subscribe(params => {
            this.urlId = +params['id'];
        });

        this.getStatusList();
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        this.callUsersListbyAdminOrPartner();

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.partnersDashboard.subscribe((value) => {
            if(!isNaN(this.urlId)){
                this.getUsersList(this.filters, this.selectedStatusId, this.urlId, this.email, this.firstName, this.wpassId);
            } else{
                this.getUsersList(this.filters, this.selectedStatusId, '', this.email, this.firstName, this.wpassId);
            }
        });
    }

    buildForm() {
        this.PartnersFiltersForm = this.formBuilder.group({
            firstName: this.formBuilder.control({value: '', disabled: this.isDisabled}),
            email: this.formBuilder.control({value: '', disabled: this.isDisabled}),
            wpassId: this.formBuilder.control(''),
        });
        this.PartnersFiltersForm.valueChanges.subscribe(data => {
            this.firstName = this.PartnersFiltersForm.get('firstName').value;
            this.email = this.PartnersFiltersForm.get('email').value;
            this.wpassId = this.PartnersFiltersForm.get('wpassId').value;
        });
    }

    disablefields(value: String) {
        if(value != ''){
            this.PartnersFiltersForm.controls['firstName'].setValue('');
            this.PartnersFiltersForm.controls['email'].setValue('');
            this.PartnersFiltersForm.controls['firstName'].disable();
            this.PartnersFiltersForm.controls['email'].disable();
        } else{
            this.PartnersFiltersForm.controls['firstName'].enable();
            this.PartnersFiltersForm.controls['email'].enable();
        }
    }

    public resetSearch(){
        this.PartnersFiltersForm.controls['firstName'].enable();
        this.PartnersFiltersForm.controls['email'].enable();
        this.PartnersFiltersForm.reset();
        this.firstName = '';
        this.email = '';
        this.wpassId = '';
        this.selectedStatusId = "";
        this.callUsersListbyAdminOrPartner();
    }

    public getStatusList(){
        this.httpService.getRequest("lookupDataOperationsApi/v1/registrationStatusFilter?includeDeleted=true").subscribe(
            res => { this.saveStatusList(res); },
            err => { this.httpService.onEnd();}
        );
    }
    public saveStatusList(res){
        if(res && res.items){
            for(let s in res.items){
                this.StatusData.push(res.items[s]);
            }
        }
    }

    public callUsersListbyAdminOrPartner(){
        this.selected = [];
        this.filters['offSet'] = 0;
        if(this.isServiceOwner || this.isTradePartner){
            this.getUsersList(this.filters, this.selectedStatusId, '', this.email, this.firstName, this.wpassId);
        } else if(this.isRegionalAdmin || this.isBUManager){
            if(this.urlId != NaN){
                this.getUsersList(this.filters, this.selectedStatusId, this.urlId, this.email, this.firstName, this.wpassId);
            }
        }
    }

    public getUsersList(filter, selectedStatus, id, email, firstName, wpassId) {
        this.searchedFilters.email=email;
        this.searchedFilters.firstName=firstName;
        this.searchedFilters.wpassId=wpassId;

        if(selectedStatus == 'PENDING'){
            this.showCheckbox = true;
        } else{
            this.showCheckbox = false;
        }

        this.httpService.getRequest("partnerOperationsApi/v1/companyUser/list?limit="+filter.limit+"&offset="+filter.offSet+"&ownerId="+id+"&status="+selectedStatus+"&email="+email+"&firstName="+firstName+"&wpassId="+wpassId).subscribe(
            res => {
                if(id){ this.saveUserList(res,filter,'admin'); }
                else { this.saveUserList(res,filter,'partners'); }
            },
            err => { this.httpService.onEnd();}
        );
    }

    public saveUserList(res, filter, type){
        this.type=type;
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if(res && Object.keys(res).length > 0 ){
                this.partnersDashboardData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;
                this.count = res.count;
                this.totalCount = res.totalCount;

                if(this.partnersDashboardData['list']) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.partnersDashboardData['list']) {
                        if(this.isBUManager || this.isRegionalAdmin ||this.isServiceOwner || this.isTradePartner){
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.partnersDashboardData['list'][data]['id'];
                            this.rows[data]['Name'] = this.partnersDashboardData['list'][data]['firstName'] +' '+this.partnersDashboardData['list'][data]['lastName'];

                            if(this.partnersDashboardData['list'][data]['roleName']){
                                this.rows[data]['roleName'] = this.partnersDashboardData['list'][data]['roleName'];
                            }

                            this.rows[data]['email'] = this.partnersDashboardData['list'][data]['email'];
                            this.rows[data]['emailVerified'] = this.partnersDashboardData['list'][data]['emailVerified'];
                            if(this.partnersDashboardData['list'][data]['userId_WPASS']){
                                this.rows[data]['userId_WPASS'] = this.partnersDashboardData['list'][data]['userId_WPASS'];
                            } else {
                                this.rows[data]['userId_WPASS'] = null;
                            }
                            this.rows[data]['languageId'] = this.partnersDashboardData['list'][data]['languageId'];
                            this.rows[data]['languageName'] = this.partnersDashboardData['list'][data]['languageName'];
                            this.rows[data]['status'] = this.partnersDashboardData['list'][data]['status'];
                            this.rows[data]['ownerId'] = this.partnersDashboardData['list'][data]['ownerId'];
                            this.rows[data]['sessionUserManager'] = this.partnersDashboardData['list'][data]['sessionUserManager'];
                            this.rows[data]['createdAt'] = this.partnersDashboardData['list'][data]['createdAt'];
                            this.rows[data]['updatedAt'] = this.partnersDashboardData['list'][data]['updatedAt'];
                        } else{
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else{
                    this.showTable = false;
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offset' && f !='totalCount' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offset'){
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if(f == 'totalCount'){
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset']/this.page.size },finalRows,filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
        if(rows.length != 0){
            this.serverResultsService.getResults(this.page,rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        console.log('type:'+this.type);
                        if(this.type == 'admin'){
                            this.getUsersList(this.filters, this.selectedStatusId, this.urlId, this.email, this.firstName, this.wpassId);
                        } else if(this.type == 'partners'){
                            this.getUsersList(this.filters, this.selectedStatusId, '', this.email, this.firstName, this.wpassId);
                        }
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
        this.selectedCount = this.selected.length;
    }

    ngOnInit(){
        this.buildForm();

        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage=res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage=res;
        });
    }

    ngOnDestroy() {
        this.dialog.closeAll();
        localStorage.removeItem('wpassLogin');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/partners-dashboard/partners-dashboard.component.ts